module.exports = __webpack_public_path__ + "img/major-prize@2x.a71bb534.png";